module.exports = __webpack_public_path__ + "img/comment_img3.3e970f5f.jpg";